// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout_gEFm6","mainHeading":"index_mainHeading_3woZL"};